import React from "react"
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CCOSvg from "../../fundamentals/CCOSvg";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import useWindowSize from "../../../utility/useWindowSize";
import {CmCollectionType} from "../../types";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";

export interface Props {
    cmCollection: CmCollectionType,
    CAEGlobalSettings: any,
}

function C071SocialRow(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    const {lowerThanWindowLarge} = useWindowSize();
    const gridStyle = {

        width: '100%',
        height: '100%',
        padding: '24px 16px 16px 16px',
    }
    const stackStyleCenter = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        alignContent: 'center'
    }
    const noStackStyle = {}
    return (
        <>
            <Box id={props.cmCollection.id} sx={gridStyle}>
                <Stack
                    direction="row"
                    style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}
                    sx={{
                        alignItems: "center",
                        gap: 4
                    }}>
                    <Typography
                        {...metaDataProperty(
                            isPreview, 'properties.teaserTitle', props.cmCollection.id)}
                        sx={{fontSize: 16, pb: 1,}}> {props.cmCollection.teaserTitle} </Typography>
                </Stack>
                <Stack
                    direction="row"
                    style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}
                    sx={{
                        alignItems: "center",
                        gap: 4
                    }}>
                    {
                        props.cmCollection.items?.map((item: any, index: number) => (
                            <Box key={index} sx={{textAlign: 'center'}}>
                                {item.globalFactsSettings?.teaser_icon ?
                                    <CCOLinkable dataCypress={'socialMediaLink' + index}
                                                 ariaLabel={item.teaserTitle ||
                                                            item.globalFactsSettings?.teaser_icon_alt ||
                                                            undefined}
                                                 target={item} openInTab={true} noLinkIcon={true}>
                                        <CCOSvg uri={item.globalFactsSettings?.teaser_icon}
                                                alt={item.globalFactsSettings?.teaser_icon_alt}
                                                size={24}/>
                                    </CCOLinkable>
                                    : null}
                            </Box>
                        ))
                    }
                </Stack>


            </Box>
        </>
    );
}

export default C071SocialRow